// src/utils/errorFilter.ts
// Filtre les erreurs d'extensions de navigateur qui ne sont pas pertinentes

export const setupErrorFilter = () => {
  // Sauvegarder la fonction console.error originale
  const originalError = console.error;
  const originalWarn = console.warn;

  // Filtrer les erreurs d'extensions de navigateur
  console.error = (...args) => {
    const message = args[0]?.toString() || '';
    
    // Ignorer les erreurs d'extensions de navigateur
    if (message.includes('listener indicated an asynchronous response') ||
        message.includes('message channel closed') ||
        message.includes('Extension context invalidated') ||
        message.includes('chrome-extension://')) {
      return; // Ignorer ces erreurs
    }
    
    // Afficher toutes les autres erreurs
    originalError.apply(console, args);
  };

  // Filtrer les warnings d'extensions
  console.warn = (...args) => {
    const message = args[0]?.toString() || '';
    
    if (message.includes('chrome-extension://') ||
        message.includes('moz-extension://')) {
      return; // Ignorer ces warnings
    }
    
    originalWarn.apply(console, args);
  };
};

// Fonction pour restaurer les fonctions originales
export const restoreConsole = () => {
  // Cette fonction peut être utilisée pour restaurer les fonctions originales si nécessaire
  console.error = console.error;
  console.warn = console.warn;
};
